import { Link } from "react-router-dom";

export function UnsubscribedPage() {
  return (
    <main className="aptean-page aptean-unsubscribed">
      <div className="aptean-unsubscribed__card">
        <h1 className="aptean-unsubscribed__heading">You've been unsubscribed.</h1>
        <p className="aptean-unsubscribed__message">
          You won't receive any more notifications. You can re-subscribe at any time.
        </p>
        <Link to="/status" className="aptean-btn aptean-btn--secondary">
          Back to status
        </Link>
      </div>
    </main>
  );
}
